export class ReportsController {
    constructor(XRayUIStorage, $scope, $rootScope, $state, $stateParams, xrayLicensesDao, SecurityReportsDao, $q) {
        this.$state = $state;
        this.XRayUIStorage = XRayUIStorage;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;

        this.xrayLicensesDao = xrayLicensesDao;
        this.SecurityReportsDao = SecurityReportsDao;
        this.$q = $q;
        this.$scope = $scope;

        this.licenseAvailable = false;
        this.securityAvailable = true;
        this.reportHasData().then(() => {
            this.reports = [

                {
                    title: "License Report",
                    desc: `This report describes the organization's usage of OSS licenses and their compliance with "Allowed Licenses" and "Banned Licenses" filters defined in all watches in the system.`,
                    type: "license",
                    icon_src: '../images/reports_license_icon.svg',
                    isAvailable: this.licenseAvailable,
                    lastUpdated: this.licenseUpdateTime

                },
                {
                    title: "Security Report",
                    desc: `This report provides an indication of the general health of your repositories with respect to security and other vulnerabilities.`,
                    type: "security",
                    icon_src: 'images/reports_security_icon.svg',
                    isAvailable: this.securityAvailable,
                    lastUpdated: this.securityUpdateTime
                }
            ];
        })

    }

    goGenerate(report) {

        this.$state.go("reports.page", {reportType: report.type, title: report.title});
    }

    reportHasData() {

        let defer = this.$q.defer();
        let total_sum = 0;

        if (this.XRayUIStorage.getItem('licenseReport') && this.XRayUIStorage.getItem('securityReport')) {
            this.securityAvailable = true;
            this.licenseAvailable = true;
            this.licenseUpdateTime = this.XRayUIStorage.getItem('licenseReport').lastUpdate;
            this.securityUpdateTime = this.XRayUIStorage.getItem('securityReport').lastUpdate;
            defer.resolve();
            return defer.promise;
        } else {
            this.xrayLicensesDao.getStatus().$promise.then((results) => {

                this.licenseAvailable = false;
                if (results.is_available) {
                    this.licenseUpdateTime = results.last_updated;
                    this.licenseAvailable = true;
                }

                this.SecurityReportsDao.getStatus().$promise.then((response) => {
                    this.securityAvailable = false;
                    if (response.is_available) {
                        this.securityUpdateTime = response.last_updated;
                        this.securityAvailable = true;
                        defer.resolve();
                    }
                    else {
                        defer.resolve();
                    }

                });
            });

            return defer.promise;
        }
    }

}



// WEBPACK FOOTER //
// ./modules/xray/states/reports/reports.controller.js